import { useContext } from 'react';
import { TranslationContext } from './TranslationContext';
/**
 * Get the current locale from the TranslationContext
 *
 * This hook rerenders when the locale changes.
 *
 * @example
 *
 * import { useLocale } from 'react-admin';
 *
 * const availableLanguages = {
 *     en: 'English',
 *     fr: 'Français',
 * }
 * const CurrentLanguage = () => {
 *     const locale = useLocale();
 *     return <span>{availableLanguages[locale]}</span>;
 * }
 */
var useLocale = function () {
    var locale = useContext(TranslationContext).locale;
    return locale;
};
export default useLocale;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ra-core/esm/i18n/useLocale.js
// module id = 414
// module chunks = 0